export default class AdesStationDto {
    constructor(obj = {}) {
        this.bsscode = obj.bsscode
        this.city = obj.city
        this.townCode = obj.townCode
        this.headers = ['bsscode']
    }
}
